/**
 * @generated SignedSource<<2db8bb82ebfb5ad8094f5641bb0b30a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendMessageTo = "community" | "product" | "%future added value";
export type SendMessageInput = {
  emailMessageInput?: SendEmailMessageInput | null;
  organizationId: string;
  organizationMembershipIds?: ReadonlyArray<string> | null;
  productId?: string | null;
  sendTo?: SendMessageTo | null;
  slackDirectMessageInput?: SendSlackDirectMessageInput | null;
};
export type SendEmailMessageInput = {
  richEditorBody: string;
  subject: string;
};
export type SendSlackDirectMessageInput = {
  richEditorBody: string;
  sendAs?: string | null;
};
export type MessageCommunityMembersDrawerContentMutation$variables = {
  input: SendMessageInput;
};
export type MessageCommunityMembersDrawerContentMutation$data = {
  readonly response: {
    readonly automation: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type MessageCommunityMembersDrawerContentMutation = {
  response: MessageCommunityMembersDrawerContentMutation$data;
  variables: MessageCommunityMembersDrawerContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendMessageResponse",
    "kind": "LinkedField",
    "name": "sendMessage",
    "plural": false,
    "selections": [
      {
        "alias": "automation",
        "args": null,
        "concreteType": "Automation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageCommunityMembersDrawerContentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageCommunityMembersDrawerContentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "601e2721149e4788a6bb210847d0be5d",
    "id": null,
    "metadata": {},
    "name": "MessageCommunityMembersDrawerContentMutation",
    "operationKind": "mutation",
    "text": "mutation MessageCommunityMembersDrawerContentMutation(\n  $input: SendMessageInput!\n) {\n  response: sendMessage(input: $input) {\n    automation: node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "08746845222974e79695c72919545d4b";

export default node;
